//HAMBURGER
document.addEventListener("DOMContentLoaded", () => {
  const hamburgerBtn = document.querySelector(".hamburger-btn");
  const mobileMenu = document.querySelector(".mobile-menu");
  const body = document.body;

  hamburgerBtn.addEventListener("click", function () {
    this.classList.toggle("active");
    mobileMenu.classList.toggle("active");
    body.classList.toggle("menu-open");
  });

  // Close menu when clicking on menu item
  const menuLinks = mobileMenu.querySelectorAll("a");
  menuLinks.forEach((link) => {
    link.addEventListener("click", () => {
      hamburgerBtn.classList.remove("active");
      mobileMenu.classList.remove("active");
      body.classList.remove("menu-open");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  "use strict";
  var cookieAlert = document.querySelector(".cookiealert");
  var acceptCookies = document.querySelector(".acceptcookies");
  if (!cookieAlert || !acceptCookies) {
    console.warn("Cookie-Alert-Elemente nicht gefunden");
    return;
  }
  if (!getCookie("acceptCookies")) {
    cookieAlert.classList.add("show");
  }
  acceptCookies.addEventListener("click", function () {
    setCookie("acceptCookies", true, 60);
    cookieAlert.classList.remove("show");
  });
});
function setCookie(cname, cvalue, exdays) {
  var d = /* @__PURE__ */ new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1e3);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
